import React, { useState } from 'react';
import { useNotifications } from '../context/NotificationContext';
import { useNewsletterSignup } from '../api/newsletter';
import './MailingListSignup.css';
import { useAnalytics } from '../context/AnalyticsContext';

const MailingListSignup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [zipCode, setZipCode] = useState('');
  const { showSuccess, showError } = useNotifications();
  const newsletterSignupMutation = useNewsletterSignup();
  const { trackEvent } = useAnalytics();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email.trim() || !zipCode.trim()) {
      showError('Please fill in both email and zip code', new Error('Please fill in both email and zip code'));
      return;
    }
    
    trackEvent('landing_page_mailing_list_signup_submitted', { email: email.trim(), zip_code: zipCode.trim() });

    try {
      await newsletterSignupMutation.mutateAsync({
        email: email.trim(),
        zip_code: zipCode.trim(),
      });
      
      showSuccess('Successfully joined our interest list!');
      setEmail('');
      setZipCode('');
    } catch (error) {
      showError('Failed to join interest list. Please try again.', error as Error);
    }
  };

  return (
    <div className="mailing-list-signup">
      <h3>Currently available only in Colorado</h3>
      <p>We'll notify you when Aika comes to your state.</p>
      
      <form onSubmit={handleSubmit} className="mailing-list-form">
        <div className="form-inputs">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={newsletterSignupMutation.isPending}
          />
          <input
            type="text"
            placeholder="Zip"
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            maxLength={5}
            pattern="[0-9]{5}"
            required
            disabled={newsletterSignupMutation.isPending}
          />
        </div>
        <button 
          type="submit" 
          className="btn btn--primary btn--md"
          disabled={newsletterSignupMutation.isPending || !email.trim() || !zipCode.trim()}
        >
          {newsletterSignupMutation.isPending ? 'Joining...' : 'Join Interest List'}
        </button>
      </form>
    </div>
  );
};

export default MailingListSignup;
